// TODO Fix everything with eslint-disable-next-line @typescript-eslint/no-redeclare
import * as types from 'types';
import { ICore } from '../../../types';

export type CoreState = ICore;

export enum CoreActionTypes {
  UPDATE_INFO_PROCESSING = '@@student/core/UPDATE_INFO_PROCESSING',
  UPDATE_ASSIGNED_AGENTS = '@@student/core/UPDATE_ASSIGNED_AGENTS',
  UPDATE_ASSIGNED_AGENTS_SUCCESS = '@@student/core/UPDATE_ASSIGNED_AGENTS_SUCCESS',
  UPDATE_ASSIGNED_AGENTS_FAILURE = '@@student/core/UPDATE_ASSIGNED_AGENTS_FAILURE',
  UPDATE_VISA_STATUS = '@@student/core/UPDATE_VISA_STATUS',
  UPDATE_LEGAL_ADVISE_DISCLAIMER = '@@student/core/UPDATE_LEGAL_ADVISE_DISCLAIMER',
}

export const Status = types.CoreStatusExtended;

export type Status = types.CoreStatusExtended;

export const { VisaStatus } = types;

export type VisaStatus = types.VisaStatus;
